import { FormIdUtil, HekateFormDefinition } from 'www-shared';
import EduAcademicWebinarProgressiveProfile from './definitions/EduAcademicWebinarProgressiveProfile';
import CommonPreFilledProgressiveProfileDefinition from './definitions/CommonPreFilledProgressiveProfileDefinition';
import EduFormProgressiveProfile from './definitions/EduFormProgressiveProfileDefinition';
import EmailSubscriptionPreferencesProfileDefinition from './definitions/EmailSubscriptionPreferencesProfileDefinition';
import EventRegistrationProgressiveProfile from './definitions/EventRegistrationProgressiveProfileDefinition';
import GatedContentProgressiveProfileDefinition from './definitions/GatedContentProgressiveProfileDefinition';
import InternalReferralProgressiveProfile from './definitions/InternalReferralProgressiveProfile';
import PhoneGatedContentProgressiveProfileDefinition from './definitions/PhoneGatedContentProgressiveProfileDefinition';
import ReferAFriendReferrerProgressiveProfile from './definitions/ReferAFriendReferrerProgressiveProfile';
import RenderStudioUpgradeProgressiveProfile from './definitions/RenderStudioUpgradeProgressiveProfile';
import UpgradeStandardToPro from './definitions/UpgradeStandardToPro';
import ProgressiveProfileDefinition from './ProgressiveProfileDefinition';
import SignupSurveyProgressiveProfile from './definitions/SignupSurveyProgressiveProfile';
import WebinarRegistrationProgressiveProfile from './definitions/WebinarRegistrationProgressiveProfile';
import CreatorProgramProgressiveProfile from './definitions/CreatorProgramProgressiveProfile';
import UnifiedSignupProgressProfile from './definitions/UnifiedSigupProgressProfile';
import StartupProgramProgressiveProfile from './definitions/StartupProgramProgressiveProfileDefinition';
import EducatorUpgradeProgressiveProfile from './definitions/EducatorUpgradeProgressiveProfile';
import ReferToDiscoProgressiveProfile from './definitions/ReferToDiscoProgressiveProfile';
import ContactSalesProgressiveProfile from './definitions/ContactSalesProgressiveProfile';
import CamForFirstRoboticsProgressiveProfile from './definitions/CamForFirstRoboticsProgressiveProfile';

export default class ProgressiveProfileDefinitionProvider {
  /**
   * Return the Progressive profile associated with this form
   *
   * Defaults to  `GatedContentProgressiveProfileDefinition`
   */
  public static getDefinition({
    formDefinition,
  }: {
    formDefinition: HekateFormDefinition | null
  }): ProgressiveProfileDefinition | null {
    if (formDefinition === null) {
      return null;
    }

    /**
    ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** **
    *** WHEN YOU ADD A FORM MAKE SURE TO UPDATE GaDataLayer.ts (simpleIdToActionMap)
    ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** **
    */
    switch (formDefinition.id) {
      case FormIdUtil.names.gatedContentProgressiveProfile:
      case FormIdUtil.names.webinarRegistration:
        return new PhoneGatedContentProgressiveProfileDefinition();
      case FormIdUtil.names.defaultContentDownloadLead:
        return new GatedContentProgressiveProfileDefinition();
      case FormIdUtil.names.referAFriendReferrer:
        return new ReferAFriendReferrerProgressiveProfile();
      case FormIdUtil.names.emailSubscriptionPreferences:
        return new EmailSubscriptionPreferencesProfileDefinition();
      case FormIdUtil.names.internalReferral:
        return new InternalReferralProgressiveProfile();
      case FormIdUtil.names.eduForm:
        return new EduFormProgressiveProfile();
      case FormIdUtil.names.upgradeRenderStudio:
        return new RenderStudioUpgradeProgressiveProfile();
      case FormIdUtil.names.upgradeStandardToPro:
        return new UpgradeStandardToPro();
      case FormIdUtil.names.upgradeToEducator:
        return new EducatorUpgradeProgressiveProfile();
      case FormIdUtil.names.camForFirstRobotics:
        return new CamForFirstRoboticsProgressiveProfile();
      case FormIdUtil.names.eventForm:
        return new EventRegistrationProgressiveProfile();
      case FormIdUtil.names.eduAcademicWebinarRegistration:
        return new EduAcademicWebinarProgressiveProfile();
      case FormIdUtil.names.signupSurvey:
        return new SignupSurveyProgressiveProfile();
      case FormIdUtil.names.webinarRegistration2023:
        return new WebinarRegistrationProgressiveProfile();
      case FormIdUtil.names.creatorProgram:
        return new CreatorProgramProgressiveProfile();
      case FormIdUtil.names.unifiedSignup:
        return new UnifiedSignupProgressProfile();
      case FormIdUtil.names.startupProgram:
        return new StartupProgramProgressiveProfile();
      case FormIdUtil.names.referToDisco:
        return new ReferToDiscoProgressiveProfile();
      case FormIdUtil.names.contactSales:
        return new ContactSalesProgressiveProfile();
      default:
        return new CommonPreFilledProgressiveProfileDefinition();
    }
    /**
    ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** **
    *** WHEN YOU ADD A FORM MAKE SURE TO UPDATE GaDataLayer.ts (simpleIdToActionMap)
    ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** **
    */
  }
}
